import { UseCase } from '../../base';
import { LocationsRepository } from '../../repositories';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { CreateEditPublicLocationRequest } from '../../domain/requests/create-edit-public-loction.request';

@Injectable({providedIn: 'root'})
export class AddPublicLocationUsecase
  implements UseCase<CreateEditPublicLocationRequest, string>
{
  constructor(private locationRepository: LocationsRepository) {}

  execute(params: CreateEditPublicLocationRequest): Observable<string> {
    return this.locationRepository.addPublicLocation(params);
  }
}
